import { MUIBaseEntity, MUITableColumn } from 'components/shared/MUITable';

export interface FinanceTableEntity extends MUIBaseEntity {
  id: string;
  opportunityId: string | null;
  customerName: string | null;
  locationBranch: string | null;
  salesRep: string | null;
  dealDate: string | null;
  dealAmount: number | null;
  equipmentSalePrice: number | null;
  equipmentCost: number | null;
  equipmentGross: number | null;
  equipmentMarginPercent: number | null;
  financeUsed: string | null;
  financeGross: number | null;
  financeProfit: number | null;
  financeMarginPercent: number | null;
  internalFinanceTier: string | null;
  lender: string | null;
  docFeeAmount: number | null;
  escSold: string | null;
  escVendor: string | null;
  escGross: number | null;
  escCost: number | null;
  escProfit: number | null;
  gapSold: string | null;
  gapVendor: string | null;
  gapGross: number | null;
  gapCost: number | null;
  gapProfit: number | null;
  insuranceSold: string | null;
  insuranceVendor: string | null;
  insuranceGross: number | null;
  insuranceCost: number | null;
  insuranceProfit: number | null;
  roadsideSold: string | null;
  roadsideVendor: string | null;
  roadsideGross: number | null;
  roadsideCost: number | null;
  roadsideProfit: number | null;
}

export type FinanceTableColumn = MUITableColumn<FinanceTableEntity>;

export enum FinanceListTabs {
  FinanceLog = 'financeLog',
}

export type FinanceListTabsType = FinanceListTabs | string;
